/**
 * @fileoverview Entry point for custom Vue plugins for Bimba y Lola.
 * Registers all internal plugins with a single call.
 */

import MsgPlugin from './msg';

/**
 * Installs all internal plugins at once.
 * @param {Object} Vue - The Vue constructor.
 * @returns {void}
 */
function install(Vue) {
  Vue.use(MsgPlugin);
}

export default { install };
